import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

/**
 * Obtiene el informe anual de mantenciones cerradas de un cliente en un rango.
 * Backend: GET /clientes/:id/informe-anual-mantenciones?desde&hasta (ver plan
 * 2026-04-20 informe-anual-mantenciones). Devuelve cliente + periodo + array
 * de mantenciones aplanadas (id, closed_at, tecnico_nombre, tecnico_rut,
 * observaciones).
 */
export function getInformeAnualMantencionesApi(clienteId, desde, hasta) {
  return axios.get(`${API_PATH}/clientes/${clienteId}/informe-anual-mantenciones`, {
    params: { desde, hasta },
    headers: { Authorization: getAccessTokenApi() },
  });
}
